<template>
  <a-popover
    trigger="hover"
    v-bind="$attrs"
    v-on="$listeners"
    :overlayClassName="'am35-battery-popover'"
  >
    <template #content>
      <div class="am35-battery-popover-content">
        <slot name="popoverContent">
          <div class="battery-default-content">
            <div class="battery-info">
              <span class="battery-label">SN</span>
              <span class="battery-value">{{ sn || "" }}</span>
            </div>
            <div class="battery-info" v-if="mouseExits === 1">
              <!-- <span class="battery-label">{{ mouseHealthLabel }}</span>
              <span class="battery-value">{{ formattedMouseHealthValue }}</span> -->
            </div>
            <div class="no-data-container" v-else>
              {{ $t("mouse.noBattery") }}
            </div>
             <div class="battery-info" v-if="dongleExits === 1">
              <!-- <span class="battery-label">{{ dongleHealthLabel }}</span>
              <span class="battery-value">{{ formattedDongleHealthValue }}</span> -->
            </div>
            <div class="no-data-container" v-else>
              {{ $t("mouse.noDongle") }}
            </div>
          </div>
        </slot>
      </div>
    </template>

    <template #default>
      <div class="popover-trigger-wrapper">
        <slot></slot>
      </div>
    </template>
  </a-popover>
</template>

<script>
import { calculateBatteryBars, formatBatteryDisplay } from '../utils/batteryUtils';

export default {
  name: "CMouseAm35BatteryPopover",
  inheritAttrs: false,

  props: {
    mouseHealthLabel: {
      type: String,
      default() {
        return this.$t("mouse.mouseHealth");
      },
    },
    mouseHealthValue: {
      type: Number,
      default: 100,
      // validator: (value) => value >= 0 && value <= 100,
    },
    mouseExits: {
      type: Number,
      default: 0,
      validator: (value) => [0, 1].includes(value),
    },
    dongleHealthLabel: {
      type: String,
      default() {
        return this.$t("mouse.dongleHealth");
      },
    },
    dongleHealthValue: {
      type: Number,
      default: 100,
      // validator: (value) => value >= 0 && value <= 100,
    },
    dongleExits: {
      type: Number,
      default: 0,
      validator: (value) => [0, 1].includes(value),
    },
    sn: {
      type: String,
      default: "",
    },
  },
  computed: {
    formattedMouseHealthValue() {
      return formatBatteryDisplay(this.mouseHealthValue, true); // 显示百分比符号
    },
    formattedDongleHealthValue() {
      return formatBatteryDisplay(this.dongleHealthValue, true); // 显示百分比符号
    },
  },
};
</script>

<style lang="scss">
@import '../styles/battery.scss';
.popover-trigger-wrapper {
  display: inline-flex;
  width: fit-content; // 根据内容自适应宽度
  height: fit-content; // 根据内容自适应高度

  > * {
    cursor: pointer;
  }
}
.am35-battery-popover {
  .ant-popover-inner {
    border-radius: 15px;
    .ant-popover-inner-content {
      padding: 0 !important;
      border-radius: 15px;
    }
  }
}
.ant-popover-inner-content {
  .am35-battery-popover-content {
    cursor: default;
    min-width: 320px;
    min-height: 130px;
    // background-image: linear-gradient(270deg, #ee92ff 0%, #42bfe9 100%);
    box-shadow: 0 0 20px 0 #4136f1;
    border-radius: 15px;
    .battery-default-content {
      width: 100%;
      height: 100%;
      padding: 12px !important;
      // background-color: #000000;
      border-radius: 15px;
      display: flex;
      flex-direction: column;
      /* 使用共享的battery-info样式 */
      .battery-status-container {
        @include flex-center;
        width: 140px;
        justify-content: flex-end;
        position: relative;
        .battery {
          @include flex-center;
          justify-content: flex-start;
          width: 31px;
          height: 18px;
          background: url("../../../assets/images/icon_battery.svg") center / 100% auto no-repeat;
          position: relative;
          margin: 0 2px 0 8px;
          padding: 3px 0 3px 4px;
          flex: none;

          .percentage {
            height: 10px;
            width: 4px;
            margin-right: 2px;
            border-radius: 1px;
            background-color: $primary-color;
            flex: none;
          }

          &.charging .percentage:last-child {
            animation: chargingChange 2s infinite linear;
          }

          .line {
            height: 150%;
            border-left: 3px solid $primary-color;
            border-right: 3px solid #171717;
            transform: rotate(-30deg);
            position: absolute;
            left: 45%;
            top: -25%;
          }
        }

        .iconfont {
          position: absolute;
          right: 9.8px;
          opacity: 0.8;
          color: #ffffff;
          animation: colorChange 2s infinite linear;
          font-size: 12px;
        }
      }
      .no-data {
        width: 100%;
        text-align: center;
      }
    }
  }
}
</style>
